import React, { useState, useEffect } from "react";
import { apiCallingPost } from '../api/services';
import Logo from "../assets/images/logo.webp";
import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer } from 'react-toastify';

// Decode the email claim from the (already-owned) verification JWT so we can prefill
// the login form. Read-only decode of the token that was in the user's own email link.
function emailFromToken(token) {
    try {
        let b64 = String(token).split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
        while (b64.length % 4) b64 += '=';
        const payload = JSON.parse(atob(b64));
        return payload.emaild || payload.email || "";
    } catch (e) {
        return "";
    }
}

function VerifyEmail() {
    const location = useLocation();
    const navigate = useNavigate();
    const [status, setStatus] = useState("verifying"); // verifying | success | error
    const [message, setMessage] = useState("");
    const [email, setEmail] = useState("");

    useEffect(() => {
        const token = new URLSearchParams(location.search).get("token");
        verify(token);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.search]);

    const verify = async (token) => {
        if (!token) {
            setStatus("error");
            setMessage("This verification link is invalid. Please request a new one.");
            return;
        }
        try {
            const data = await apiCallingPost("api/authentication/verifyEmail", { token });
            if (data.data.success === "1") {
                const em = emailFromToken(token);
                setEmail(em);
                setStatus("success");
                setMessage(data.data.successMessage || "Your email has been verified. You can now log in.");
                // Route to the login page with the email prefilled so they can just enter the password.
                setTimeout(() => navigate("/login", { state: { email: em } }), 3000);
            } else {
                setStatus("error");
                setMessage(data.data.errorMessage || "This verification link is invalid or has expired.");
            }
        } catch (e) {
            setStatus("error");
            setMessage("Something went wrong. Please try again later.");
        }
    };

    return (
        <div className="modal-admin-wrapper popup-outer-div">
            <div className="p-4">
                <a className='login_logo' href="/">
                    <img src={Logo} alt="Logo" className="img-fluid logo-change" width="120" height="50" />
                </a>
            </div>
            <div className="modal-ad-popup modal-md">
                <div className="modal-innerpopup">
                    <h5 className="modal-head">Email Verification</h5>
                    <div className="my-3">
                        {status === "verifying" && <p>Verifying your email…</p>}
                        {status === "success" && <p style={{ color: 'green' }}>{message}</p>}
                        {status === "error" && <p style={{ color: 'red' }}>{message}</p>}
                    </div>
                    {status !== "verifying" && (
                        <button type="button" className="accept-all-btn w-100 py-2" onClick={() => navigate("/login", { state: { email } })}>
                            Go to Sign In
                        </button>
                    )}
                </div>
            </div>
            <ToastContainer />
        </div>
    );
}

export default VerifyEmail;
